/**
 * Frame of the portal's public pages (register, verify, accept invite, forgot
 * / reset password, sign in): a centered card on a plain background. These
 * pages need no staff AuthProvider chrome (only the sign-in page uses the
 * session); they are reachable signed in or out.
 */
import React, { useEffect } from 'react';

export function PortalPublicLayout({ title, intro, children }: { title: string; intro?: React.ReactNode; children: React.ReactNode }) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} - Customer portal`;
    return () => { document.title = previous; };
  }, [title]);
  return (
    <div className="min-h-screen bg-gray-100 px-4 py-8">
      <main className="mx-auto w-full max-w-md rounded-lg bg-white p-5 shadow sm:p-8">
        <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-blue-700">Customer portal</p>
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {intro && <div className="mt-2 text-sm text-gray-600">{intro}</div>}
        <div className="mt-5">{children}</div>
      </main>
    </div>
  );
}

export const portalLinkClass = 'inline-flex min-h-[44px] items-center text-sm font-semibold text-blue-700 hover:underline';
